import styled from "styled-components";
import { size } from "styled-theme";

export const PaddingTopMobile = styled.div`
  @media only screen and (max-width: ${size("S")}) {
    padding-top: ${(props) => props.$padding}px; 
  }
`;